module.exports = __webpack_public_path__ + "static/media/temp_person_likes.372564d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/temp_person_likes.png
// module id = 602
// module chunks = 0